const PAGE_NAME = 'collection_page';

module.exports = {
    PAGE_NAME,
};
